module.exports = __webpack_public_path__ + "static/images/apple-gift-con-bg01.486dddf.png";